const docSiteUrl = 'https://fluentsite.z22.web.core.windows.net';

const constants = {
  docSiteUrl,
  quickStartUrl: `${docSiteUrl}/quick-start`,
  repoURL: 'https://github.com/microsoft/fluentui',
  typeOrder: ['component', 'behavior'],
};

export default constants;
